(function () {
  function extractBadges(text) {
    var badges = [];
    var dim = text.match(/(\d+(?:[.,]\d+)?)\s*[x×X]\s*(\d+(?:[.,]\d+)?)\s*mm/);
    if (dim) {
      badges.push(dim[1].replace(',', '.') + ' × ' + dim[2].replace(',', '.') + ' mm');
    }
    var mandrin = text.match(/Mandrin\s*[ØOø]?\s*(\d+(?:[.,]\d+)?)\s*mm/i) || text.match(/Ø\s*(\d+(?:[.,]\d+)?)\s*mm/);
    if (mandrin) {
      badges.push('Ø ' + mandrin[1].replace(',', '.') + ' mm');
    }
    return badges;
  }

  function injectBadges(el) {
    if (!el || el.dataset.cardSpecsDone) return;
    el.dataset.cardSpecsDone = '1';
    var text = el.textContent || '';
    var badges = extractBadges(text);
    if (!badges.length) return;
    var row = document.createElement('div');
    row.className = 'card-spec-badges';
    row.innerHTML = badges
      .map(function (b) {
        return '<span class="card-spec-badge">' + b + '</span>';
      })
      .join('');
    if (el.parentNode) {
      el.parentNode.insertBefore(row, el);
    }
  }

  var SELECTOR = '.card__heading, .fi__pcard-title';

  function scan(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(injectBadges);
  }

  function init() {
    scan();
    var mo = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          if (n.matches && n.matches(SELECTOR)) injectBadges(n);
          if (n.querySelectorAll) scan(n);
        });
      });
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
